import React from "react";

/* eslint react/prop-types: 0 */
/* eslint max-len: 0 */

// Icons specific to Powered By
export const BellIcon = ({
  className = "",
  height = 36,
  width = 34,
  fill = "#57567a"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 34 36"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Icons"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      opacity="0.249609375"
    >
      <g id="Bell" fill={fill}>
        <path
          d="M17.2059379,0 L16.5443881,0 C15.6325585,0 14.8897178,0.739647338 14.8897178,1.65109451 L14.8897178,3.38965667 C10.1775372,3.8429981 5.51473521,6.3243838 5.51473521,16.8384194 C5.51473521,25.897104 0.193689279,29.7370481 0.141046056,29.7753253 C0.0230844291,29.8580368 -0.0279264454,30.0075585 0.0151144901,30.144355 C0.0581554256,30.2827395 0.187278232,30.375 0.330745296,30.375 L33.4192547,30.375 C33.5627218,30.375 33.690249,30.2811514 33.7348855,30.144355 C33.7779264,30.0075585 33.7269156,29.8580409 33.6089539,29.7753253 C33.5547559,29.7371499 28.2352644,25.9179936 28.2352644,16.8384194 C28.2352644,6.3243838 23.5724624,3.84287594 18.8602818,3.38965667 L18.8602818,1.65109451 C18.8586862,0.739647338 18.1174411,0 17.2056115,0 L17.2059379,0 Z"
          id="Fill-1"
        />
        <path
          d="M16.3125,36 C19.1096978,36 21.375,33.986324 21.375,31.5 L11.25,31.5 C11.25,33.986398 13.5153855,36 16.3125,36 Z"
          id="Fill-2"
        />
      </g>
    </g>
  </svg>
);

export const ActiveFeedIcon = ({
  className = "",
  height = 30,
  width = 37,
  fill = "none"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 37 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill={fill} fillRule="evenodd">
      <polygon
        id="Active"
        fill="#6267e6"
        points="10 30 0 20 3.33257143 16.6674286 10 23.3348571 33.3325714 0 36.6651429 3.3348"
      />
    </g>
  </svg>
);

export const CreateFeedIcon = ({
  className = "",
  height = 16,
  width = 12,
  fill = "#ffffff"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 12 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Create-a-feed" fill={fill} fillRule="nonzero">
        <path
          d="M0,16 L0,0 L11.4782609,0 L11.4782609,0.52173913 L11.4782609,12.9130435 L8.39130435,16 L0.52173913,16 L0,16 Z M1.04347826,14.9565217 L7.65217391,14.9565217 L7.65217391,12.173913 L10.4347826,12.173913 L10.4347826,1.04347826 L1.04347826,1.04347826 L1.04347826,14.9565217 Z M8.69565217,14.2228174 L9.70107826,13.2173913 L8.69565217,13.2173913 L8.69565217,14.2228174 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

export const CreateIcon = ({
  className = "",
  height = 16,
  width = 16,
  fill = "#5d69e6"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Create-a-file" fill={fill}>
        <polygon id="Path" points="6.4 0 9.6 0 9.6 16 6.4 16" />
        <polygon id="Path" points="0 6.4 16 6.4 16 9.6 0 9.6" />
      </g>
    </g>
  </svg>
);

export const DeleteIcon = ({
  className = "",
  height = 16,
  width = 16,
  fill = "#fa5a62"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon
        id="Delete"
        fill={fill}
        points="1.88752 0 8 6.11248 14.11248 0 16 1.88752 9.88752 8 16 14.11248 14.11248 16 8 9.88752 1.88752 16 0 14.11248 6.11248 8 5.68434189e-16 1.88752"
      />
    </g>
  </svg>
);

export const GenerateAdHocFileIcon = ({
  className = "",
  height = 16,
  width = 12,
  fill = "none"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 12 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill={fill} fillRule="evenodd">
      <path
        d="M0,16 L0,0 L11.4782609,0 L11.4782609,0.52173913 L11.4782609,12.9130435 L8.39130435,16 L0.52173913,16 L0,16 Z M1.04347826,14.9565217 L7.65217391,14.9565217 L7.65217391,12.173913 L10.4347826,12.173913 L10.4347826,1.04347826 L1.04347826,1.04347826 L1.04347826,14.9565217 Z M8.69565217,14.2228174 L9.70107826,13.2173913 L8.69565217,13.2173913 L8.69565217,14.2228174 Z"
        id="Generate-Ad-Hoc-File"
        fill="#5d69e6"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export const PauseIcon = ({
  className = "",
  height = 16,
  width = 13,
  fill = "#5d69e6"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 13 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill={fill} fillRule="evenodd">
      <g id="Pause" fill={fill}>
        <polygon id="Path" points="0.05184 0 4.06 0 4.06 16 0.05184 16" />
        <polygon id="Path" points="8.1 0 12.10816 0 12.10816 16 8.1 16" />
      </g>
    </g>
  </svg>
);

export const S3KeysIcon = ({
  className = "",
  height = 16,
  width = 16,
  fill = "#5d69e6"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="S3-Keys" fill={fill} fillRule="nonzero">
        <path
          d="M15.1428571,1.0624 L14.11696,0.0382857143 L5.75261714,8.40354286 C5.17940571,8.02317714 4.49458286,7.79908571 3.75707429,7.79908571 C1.75885714,7.79908571 0.133074286,9.42587429 0.133074286,11.424 C0.133074286,13.4231086 1.75897143,15.048 3.75707429,15.048 C5.75517714,15.048 7.38198857,13.4221029 7.38198857,11.424 C7.38198857,10.6864914 7.15788114,10.0007771 6.77842286,9.42845714 L11.00608,5.19988571 L12.66768,6.86148571 L13.6926857,5.83648 L12.0310857,4.17488 L13.1801829,3.02578286 L14.8417829,4.68738286 L15.8667886,3.66237714 L14.2051886,1.99988571 L15.1428571,1.0624 Z M3.75725714,13.5981714 C2.55814857,13.5981714 1.58315429,12.6231771 1.58315429,11.4240686 C1.58315429,10.22496 2.55814857,9.24907429 3.75725714,9.24907429 C4.95636571,9.24907429 5.93136,10.2240686 5.93136,11.4240686 C5.93136,12.6231771 4.95636571,13.5981714 3.75725714,13.5981714 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

export const TVAdExposureIcon = ({
  className = "",
  height = 14,
  width = 21,
  fill = "#00b592"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 21 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="TV-Ad-Exposure" fill={fill}>
        <path
          d="M10.5,4 C9.12518373,4 8,5.35024498 8,7 C8,8.64975502 9.12520415,10 10.5,10 C11.8747959,10 13,8.64975502 13,7 C13,5.35024498 11.8747959,4 10.5,4 Z"
          id="Path"
        />
        <path
          d="M20.8615235,6.5655639 C20.8155869,6.51751845 19.7077705,4.92366437 17.8844174,3.30679048 C15.4383235,1.13452717 12.8771166,0 10.5,0 C4.80021221,0 0.323019071,6.29969605 0.138476483,6.56580043 C-0.0461588278,6.83098232 -0.0461588278,7.1691596 0.138476483,7.41030931 C0.184413114,7.48237983 1.2922295,9.07624102 3.11558264,10.6932095 C5.56167654,12.8654728 8.12288341,14 10.5,14 C16.1997878,14 20.6769809,7.70030395 20.8615235,7.43514572 C21.0461588,7.16904133 21.0461588,6.83086405 20.8615235,6.56568216 L20.8615235,6.5655639 Z M10.5,11.3443256 C8.21538086,11.3443256 6.34620869,9.38920343 6.34620869,6.99984625 C6.34620869,4.61048907 8.21551655,2.65536695 10.5,2.65536695 C12.7844834,2.65536695 14.6537913,4.61048907 14.6537913,6.99984625 C14.6537913,9.38920343 12.7844834,11.3443256 10.5,11.3443256 Z"
          id="Shape"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
);

export const ViewFileIcon = ({
  className = "",
  height = 16,
  width = 24,
  fill = "#5d69e6"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 24 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="View-File" fill={fill}>
        <path
          d="M12,0 C4.94189395,0 0,8 0,8 C0,8 3.59986448,16 12,16 C20.4702694,16 24,8 24,8 C24,8 19.1295951,2.48029579e-15 12,0 Z M12,13.0901475 C9.24716246,13.0901475 7.05946129,10.8361986 7.05946129,8 C7.05946129,5.16380138 9.24716246,2.90985252 12,2.90985252 C14.7528375,2.90985252 16.9405387,5.16380138 16.9405387,8 C16.9405387,10.8361986 14.7528375,13.0901475 12,13.0901475 L12,13.0901475 Z"
          id="Shape"
          fillRule="nonzero"
        />
        <path
          d="M13.6,8.4 C13.6,9.504992 12.704992,10.4 11.6,10.4 C10.495008,10.4 9.6,9.504992 9.6,8.4 C9.6,7.295008 10.495008,6.4 11.6,6.4 C12.704992,6.4 13.6,7.295008 13.6,8.4"
          id="Path"
        />
      </g>
    </g>
  </svg>
);

export const ProcessingFeedIcon = ({
  className = "",
  height = 30,
  width = 30,
  fill = "#fac666"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 30 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M15,0 C6.71541667,0 0,6.71541667 0,15 C0,23.2845833 6.71541667,30 15,30 C23.2845833,30 30,23.2845833 30,15 C30,6.71541667 23.2845833,0 15,0 Z M15,3.75 C15.460625,3.75 15.8333333,4.12272083 15.8333333,4.58333333 L15.8333333,14.6616667 L22.37,21.185 C22.6955208,21.5105208 22.6955208,22.044375 22.37,22.3699167 C22.0444792,22.6954583 21.510625,22.6954375 21.1850833,22.3699167 L14.41425,15.5861667 C14.2628833,15.4348 14.1668542,15.2297208 14.1668542,15.00025 L14.1668542,4.58358333 C14.1668542,4.12295833 14.539575,3.75025 15.0001875,3.75025 L15,3.75 Z"
        id="Processing"
        fill={fill}
      />
    </g>
  </svg>
);

export const NeedsAttentionFeedIcon = ({
  className = "",
  height = 30,
  width = 37,
  fill = "#f94d63"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 37 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M18.2024996,0 L-1.42108547e-14,30 L36.4065786,30 L18.2024996,0 Z M18.2024996,10.1751316 C19.0552101,10.1751316 19.7459996,10.8659211 19.7459996,11.7186316 L19.3512628,20.9286316 C19.3111733,21.7612895 18.6650917,22.0773947 18.2024996,22.0773947 C17.6844075,22.0773947 17.0984601,21.8044697 17.0537364,20.9286316 L16.6589996,11.7186316 C16.6589996,10.8659211 17.3497891,10.1751316 18.2024996,10.1751316 Z M18.2024996,27.3228947 C17.6813286,27.3228947 17.1755522,27.1131908 16.8054864,26.7462237 C16.4385036,26.3792408 16.2288154,25.8703816 16.2288154,25.3492105 C16.2288154,24.8326579 16.4385193,24.3222632 16.8054864,23.9553158 C17.1724693,23.5883329 17.6813286,23.3755263 18.2024996,23.3755263 C18.7236707,23.3755263 19.229447,23.5883132 19.5963943,23.9553158 C19.9664601,24.3238382 20.1761838,24.8326974 20.1761838,25.3492105 C20.1761838,25.8703816 19.9664799,26.3792368 19.5963943,26.7462237 C19.2294114,27.1147461 18.7236707,27.3228947 18.2024996,27.3228947 Z"
        id="Warning"
        fill={fill}
      />
    </g>
  </svg>
);

export const InactiveFeedIcon = ({
  className = "",
  height = 30,
  width = 30,
  fill = "#9b9ab7"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 30 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M22.6516282,23.2497815 C13.8693147,23.2497815 6.75052246,16.1313693 6.75052246,7.34867579 C6.75052246,4.69775689 7.40361988,2.1981432 8.55242993,0 C3.47029245,2.65388269 0,7.96917153 0,14.0988943 C0,22.8812078 7.11841222,30 15.9011057,30 C22.0312084,30 27.3462693,26.5297835 30,21.4475701 C27.8017808,22.5963801 25.303915,23.2494775 22.6513242,23.2494775 L22.6516282,23.2497815 Z"
        id="Finished"
        fill={fill}
      />
    </g>
  </svg>
);

export const EllipseIcon = ({
  className = "",
  height = 30,
  width = 7,
  fill = "#d1d1e5"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 7 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M3.38650898,0 C5.18563265,0 6.66666667,1.48117582 6.66666667,3.38650898 C6.66666667,5.18563265 5.18549085,6.66666667 3.38650898,6.66666667 C1.48216843,6.66666667 0,5.18549085 0,3.38650898 C0,1.48216843 1.48117582,0 3.38650898,0 Z"
        id="path-1"
      />
      <filter
        x="-45.0%"
        y="-45.0%"
        width="190.0%"
        height="190.0%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feGaussianBlur
          stdDeviation="2.5"
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset
          dx="0"
          dy="1"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
          type="matrix"
          in="shadowInnerInner1"
        />
      </filter>
      <path
        d="M3.28015768,11.1111111 C5.18449823,11.1111111 6.66666667,12.5922869 6.66666667,14.4976201 C6.66666667,16.2967438 5.18549085,17.7777778 3.28015768,17.7777778 C1.48103402,17.7777778 0,16.296602 0,14.4976201 C0,12.5932795 1.48117582,11.1111111 3.28015768,11.1111111 Z"
        id="path-3"
      />
      <filter
        x="-45.0%"
        y="-45.0%"
        width="190.0%"
        height="190.0%"
        filterUnits="objectBoundingBox"
        id="filter-4"
      >
        <feGaussianBlur
          stdDeviation="2.5"
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset
          dx="0"
          dy="1"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
          type="matrix"
          in="shadowInnerInner1"
        />
      </filter>
      <path
        d="M3.38650898,23.3333333 C5.18563265,23.3333333 6.66666667,24.8145094 6.66666667,26.6134915 C6.66666667,28.5178314 5.18549085,30 3.38650898,30 C1.58752712,30 0,28.518824 0,26.6134915 C0,24.8143676 1.58752712,23.3333333 3.38650898,23.3333333 Z"
        id="path-5"
      />
      <filter
        x="-45.0%"
        y="-45.0%"
        width="190.0%"
        height="190.0%"
        filterUnits="objectBoundingBox"
        id="filter-6"
      >
        <feGaussianBlur
          stdDeviation="2.5"
          in="SourceAlpha"
          result="shadowBlurInner1"
        />
        <feOffset
          dx="0"
          dy="1"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
          type="matrix"
          in="shadowInnerInner1"
        />
      </filter>
    </defs>
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Ellipse">
        <g id="Fill-1">
          <use fill={fill} fillRule="evenodd" href="#path-1" />
          <use
            fill="black"
            fillOpacity="1"
            filter="url(#filter-2)"
            href="#path-1"
          />
        </g>
        <g id="Fill-2">
          <use fill={fill} fillRule="evenodd" href="#path-3" />
          <use
            fill="black"
            fillOpacity="1"
            filter="url(#filter-4)"
            href="#path-3"
          />
        </g>
        <g id="Fill-3">
          <use fill={fill} fillRule="evenodd" href="#path-5" />
          <use
            fill="black"
            fillOpacity="1"
            filter="url(#filter-6)"
            href="#path-5"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const CloseIcon = ({
  className = "",
  height = 16,
  width = 16,
  fill = "#797B81"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g className="svgIcon">
        <g transform="translate(2.000000, 2.000000)">
          <g>
            <path
              fill={fill}
              d="M7.89831004,6 L11.9106471,10.012337 C12.0297843,10.1314743 12.0297843,10.3246339 11.9106471,10.4437711 L10.4437711,11.9106471 C10.3246339,12.0297843 10.1314743,12.0297843 10.012337,11.9106471 L6,7.89831004 L1.98766297,11.9106471 C1.86852574,12.0297843 1.67536611,12.0297843 1.55622888,11.9106471 L0.089352926,10.4437711 C-0.0297843087,10.3246339 -0.0297843087,10.1314743 0.089352926,10.012337 L4.10168996,6 L0.089352926,1.98766297 C-0.0297843087,1.86852574 -0.0297843087,1.67536611 0.089352926,1.55622888 L1.55622888,0.089352926 C1.67536611,-0.0297843087 1.86852574,-0.0297843087 1.98766297,0.089352926 L6,4.10168996 L10.012337,0.089352926 C10.1314743,-0.0297843087 10.3246339,-0.0297843087 10.4437711,0.089352926 L11.9106471,1.55622888 C12.0297843,1.67536611 12.0297843,1.86852574 11.9106471,1.98766297 L7.89831004,6 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const DropdownCaretIcon = ({
  className = "",
  height = 5,
  width = 8,
  fill = "#5d69e6"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 8 5"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M7.99883939,0.0650758995 C7.99851124,0.0626504279 7.99785327,0.0606295465 7.99719614,0.0582040749 C7.996539,0.0553750479 7.99588187,0.0525460208 7.99522389,0.0501205492 C7.99423777,0.0472904875 7.99292351,0.0448660506 7.99193739,0.0424405791 C7.99095127,0.0404196976 7.99029414,0.0383988162 7.98930801,0.0363779348 C7.98437826,0.0274852288 7.97813339,0.0198052586 7.9709024,0.0141472046 C7.96925915,0.0129344688 7.96761589,0.0121252884 7.96630079,0.0109135874 C7.9640004,0.00929626142 7.96202816,0.0076799702 7.95972777,0.0064672344 C7.95775553,0.00525449861 7.95545515,0.00484990842 7.95315392,0.00404176281 C7.95118252,0.0032336172 7.94921028,0.00242443683 7.94723804,0.00202088141 C7.94296541,0.000808145611 7.93869279,0.000403555427 7.93474831,0.000403555427 L7.93441932,0.000403555427 L0.065651983,0 C0.0613791881,0 0.0571067298,0.000403555427 0.0528341032,0.00161629122 C0.0508620311,0.00202088141 0.0492186937,0.00282902702 0.0472467058,0.00363717263 C0.044945983,0.004446353 0.0426452603,0.00525449861 0.0403445375,0.00606264422 C0.0380438989,0.00727538001 0.0364005615,0.00848811581 0.0340998388,0.010104407 C0.0324564173,0.0113171428 0.0304844293,0.0121252884 0.028841092,0.0137426144 C0.0252256825,0.0165716414 0.0219389237,0.0202098488 0.0189807314,0.0238480562 C0.0160227073,0.0274852288 0.0133933339,0.0315269916 0.0107639605,0.0359743794 C0.00977792448,0.0379952608 0.00879188842,0.0400161422 0.00813458714,0.0420370236 C0.00714855108,0.0444624952 0.00583386438,0.046886932 0.00484791246,0.0497169938 C0.0038618764,0.0525460208 0.00353314162,0.0553760826 0.00287584034,0.0578005194 C0.00221853906,0.060225991 0.00156115364,0.0622468724 0.001232503,0.064672344 C-0.000410834335,0.0751813413 -0.000410834335,0.0856903385 0.001232503,0.0962003704 C0.00156115364,0.098625842 0.00221853906,0.100646723 0.00287584034,0.103072195 C0.00353314162,0.105901222 0.00419052704,0.108730249 0.00484791246,0.111560311 C0.00583386438,0.114389338 0.00714855108,0.116814809 0.00813458714,0.119240281 C0.0091206232,0.121261162 0.00977792448,0.123282044 0.0107639605,0.125302925 C0.0130646833,0.129749278 0.0160227073,0.133791041 0.0189807314,0.137832804 L3.95353285,4.97615194 C3.96635073,4.99191544 3.98311309,5 3.99987545,5 C4.01663781,5 4.03340017,4.99191647 4.04621805,4.97615194 L7.98043377,0.137832804 C7.98339214,0.134194596 7.98634965,0.129748243 7.98865088,0.125302925 C7.989637,0.123282044 7.99029414,0.121261162 7.99128026,0.119240281 C7.99259452,0.116814809 7.99358064,0.113984748 7.99456676,0.111560311 C7.99555288,0.108730249 7.99588187,0.106305812 7.996539,0.10347575 C7.99719614,0.101050279 7.99785327,0.0990293975 7.99818226,0.0966049606 C8.00048264,0.0864995188 8.00048264,0.0755869662 7.99883939,0.0650769342 L7.99883939,0.0650758995 Z"
        id="Dropdown-Caret-blue"
        fill={fill}
      />
    </g>
  </svg>
);

export const SideCaretIcon = ({
  className = "",
  height = 6,
  width = 11,
  fill = "#ffffff"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 11 6"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M5.49987107,6 C5.37756257,6 5.26028595,5.95075197 5.17395942,5.86456513 L0.134899245,0.791250233 C-0.0449664151,0.610188347 -0.0449664151,0.316865717 0.134899245,0.135796415 C0.314764906,-0.0452654716 0.606149633,-0.0452654716 0.786022661,0.135796415 L5.5,4.88186646 L10.2139773,0.136538046 C10.393843,-0.0445238402 10.6852277,-0.0445238402 10.8651008,0.136538046 C11.0449664,0.317599933 11.0449664,0.610922562 10.8651008,0.791991864 L5.82604058,5.8638235 C5.73898469,5.95073343 5.62242638,5.99998331 5.50012893,5.99998331 L5.49987107,6 Z"
        id="Side-Caret"
        fill={fill}
      />
    </g>
  </svg>
);

export const SearchIcon = ({
  className = "",
  height = 16,
  width = 16,
  fill = "#9b9bc2"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Search" fill={fill}>
        <path
          d="M6.74509804,13.3915294 C4.98839216,13.3994951 3.30023529,12.7083137 2.05333333,11.4705882 C0.805788235,10.2328471 0.10227451,8.54964706 0.0974117647,6.79294118 C0.091897098,5.03560784 0.786133333,3.34870588 2.02572549,2.10352941 C3.26530196,0.858431373 4.94917647,0.157490196 6.7065098,0.155607843 C8.46321569,0.153156863 10.1494902,0.849239216 11.3921569,2.09129412 C12.6354196,3.33272157 13.3339608,5.01772549 13.3333333,6.77505882 C13.3351716,8.52501961 12.6421647,10.204549 11.4075294,11.4453333 C10.1722353,12.6855216 8.49584314,13.3852549 6.74509804,13.3913725 L6.74509804,13.3915294 Z M6.74509804,2.08643137 C5.5,2.07785302 4.30211765,2.5656 3.41662745,3.44120784 C2.53113725,4.31681569 2.03060392,5.50865882 2.02508235,6.75367843 C2.01956769,7.99938824 2.50975686,9.19540392 3.38721569,10.0790118 C4.26467451,10.9625882 5.45764706,11.4607529 6.70345098,11.4632 C7.94854902,11.4662637 9.14407843,10.9736157 10.0251765,10.0937098 C10.9069176,9.21441569 11.4026196,8.02014118 11.4026196,6.77512157 C11.4050706,5.53615686 10.9167059,4.34625882 10.0435451,3.46751373 C9.17038431,2.58821961 7.98409412,2.09190588 6.74519216,2.08638431 L6.74509804,2.08643137 Z"
          id="Shape"
          fillRule="nonzero"
        />
        <polygon
          id="Path"
          points="14.4798431 15.8431373 10.312 11.7003922 11.6771922 10.3339765 15.8433098 14.4767216"
        />
      </g>
    </g>
  </svg>
);

export const CheckmarkIcon = ({
  className = "",
  height = 9,
  width = 12,
  fill = "#5d69e6"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 12 9"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Dropdowns"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        transform="translate(-830.000000, -358.000000)"
        fill={fill}
        fillRule="nonzero"
        id="Group-3"
      >
        <g transform="translate(708.000000, 232.000000)">
          <polygon
            id="Shape-Copy"
            points="132.728637 126 126.095655 132.598965 123.12518 130.236921 122 131.636183 125.600576 134.501872 126.230677 135 134 127.270521"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const NoFeedsIcon = ({
  className = "",
  height = 30,
  width = 30,
  fill = "#9B9AB7"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 30 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M24.0913953,22.2627907 C26.608186,20.4913605 28.5634884,17.9867442 29.595,14.9916279 C29.6713081,14.7708802 29.6713081,14.5310581 29.595,14.3116744 C27.5101395,8.25481395 21.6453488,4.18597674 14.9996512,4.18597674 C12.4051744,4.18597674 9.93453488,4.81280233 7.75709302,5.92880233 L2.13488372,0.306593023 C1.7260814,-0.102209302 1.06384884,-0.102209302 0.655046512,0.306593023 C0.246244186,0.715395349 0.246244186,1.37762791 0.655046512,1.78643023 L5.90818605,7.03956977 C3.39139535,8.811 1.43609302,11.3156163 0.404581395,14.3107326 C0.328273256,14.5314802 0.328273256,14.7713023 0.404581395,14.990686 C3.42010465,23.7538256 13.8906279,27.6524302 22.241093,23.3721977 L27.8633023,28.994407 C28.2721047,29.4032093 28.9343372,29.4032093 29.3431395,28.994407 C29.7519419,28.5856047 29.7519419,27.9233721 29.3431395,27.5145698 L24.0913953,22.2627907 Z M15,6.27906977 C20.6263953,6.27906977 25.5987209,9.62846512 27.4925581,14.6511628 C26.5373372,17.184314 24.7972326,19.2910465 22.5872093,20.7572093 L20.1126279,18.2826279 C20.8443837,17.2565581 21.2790698,16.0056628 21.2790698,14.6512326 C21.2790698,11.1887442 18.4624884,8.37216279 15,8.37216279 C13.6455349,8.37216279 12.3946047,8.80684884 11.3672093,9.53860465 L9.32459302,7.49598837 C11.0592558,6.71382558 12.9859884,6.27913953 15.0001744,6.27913953 L15,6.27906977 Z M11.4066279,12.5375581 L17.1132558,18.244186 C16.4905116,18.6121047 15.7737907,18.8369302 14.9997907,18.8369302 C12.6914651,18.8369302 10.8137442,16.9592093 10.8137442,14.6508837 C10.8137442,13.8768837 11.0385802,13.1601628 11.4064884,12.5374186 L11.4066279,12.5375581 Z M12.8864651,11.0577209 C13.5092093,10.6898023 14.2259302,10.4649767 14.9999302,10.4649767 C17.3082558,10.4649767 19.1859767,12.3426977 19.1859767,14.6510233 C19.1859767,15.4250233 18.9611407,16.1417442 18.5932326,16.7644884 L12.8864651,11.0577209 Z M2.50716279,14.651093 C3.46238372,12.1179419 5.20248837,10.0112093 7.41251163,8.54504651 L9.88709302,11.0196279 C9.15533721,12.0456977 8.72065116,13.296593 8.72065116,14.6510233 C8.72065116,18.1135116 11.5372326,20.930093 14.9997209,20.930093 C16.354186,20.930093 17.6051163,20.495407 18.6325116,19.7636512 L20.6751279,21.8062674 C13.6233837,24.9812442 5.17489535,21.7272349 2.50698837,14.6509186 L2.50716279,14.651093 Z"
        id="No-Feed"
        fill={fill}
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export const ResumeIcon = ({
  className = "",
  height = 16,
  width = 16,
  fill = "#5d69e6"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon
        id="Resume"
        fill={fill}
        fillRule="nonzero"
        points="1.18423789e-15 0 8 3.93366667 16 8 8.06633333 11.966 0 16"
      />
    </g>
  </svg>
);

export const LogoIcon = ({
  className = "",
  height = 23.65,
  width = 129,
  fill = "#626380"
}) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 120 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <polygon
        id="path-1"
        points="0 0.0561320755 119.914151 0.0561320755 119.914151 21.3207204 0 21.3207204"
      />
    </defs>
    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="samba_logo_heart_Wordmark_White_2018">
        <path
          d="M33.0084906,15.5410377 L33.9035849,13.9606604 C34.055,13.7139623 34.4189623,13.7509434 34.5527358,13.8464151 C34.6283019,13.8839623 36.0003774,14.8920755 37.2570755,14.8920755 C38.019434,14.8920755 38.5732075,14.4175472 38.5732075,13.7509434 C38.5732075,12.9530189 37.9060377,12.3437736 36.6080189,11.8295283 C34.9696226,11.1825472 32.9133962,9.9090566 32.9133962,7.6259434 C32.9133962,5.74207547 34.3811321,3.83943396 37.3153774,3.83943396 C39.2969811,3.83943396 40.8206604,4.8459434 41.3921698,5.26556604 C41.6207547,5.39933962 41.5838679,5.74207547 41.5065094,5.87622642 L40.5349057,7.34066038 C40.4013208,7.54811321 40.06,7.72132075 39.8862264,7.58839623 C39.7156604,7.49320755 38.3254717,6.44566038 37.1627358,6.44566038 C36.4754717,6.44566038 35.9615094,6.90254717 35.9615094,7.41424528 C35.9615094,8.12009434 36.5345283,8.65207547 38.0400943,9.26150943 C39.5245283,9.85084906 41.8862264,11.0126415 41.8862264,13.5986792 C41.8862264,15.5585849 40.1921698,17.5374528 37.3915094,17.5374528 C34.9138679,17.5374528 33.5410377,16.5110377 33.1039623,16.0717925 C32.9133962,15.8819811 32.8556604,15.8058491 33.0084906,15.5410377"
          id="Fill-1"
          fill={fill}
        />
        <path
          d="M49.8557547,12.8186792 L48.4172642,9.68830189 L48.3979245,9.68830189 L46.9789623,12.8186792 L49.8557547,12.8186792 Z M42.0779245,16.874434 L48.0023585,4.11471698 C48.0574528,4.00113208 48.1899057,3.90584906 48.3232075,3.90584906 L48.5108491,3.90584906 C48.6449057,3.90584906 48.7773585,4.00113208 48.8325472,4.11471698 L54.7561321,16.874434 C54.8703774,17.1204717 54.7185849,17.3666981 54.4349057,17.3666981 L52.3353774,17.3666981 C51.9960377,17.3666981 51.8417925,17.2529245 51.6717925,16.8942453 L50.9914151,15.395 L45.8425472,15.395 L45.1611321,16.9118868 C45.0675472,17.1392453 44.8587736,17.3666981 44.4818868,17.3666981 L42.3986792,17.3666981 C42.1164151,17.3666981 41.9635849,17.1204717 42.0779245,16.874434 L42.0779245,16.874434 Z"
          id="Fill-2"
          fill={fill}
        />
        <path
          d="M57.9580189,4.42632075 C57.9767925,4.25490566 58.1467925,4.12226415 58.2990566,4.12226415 L58.6036792,4.12226415 C58.6985849,4.12226415 58.8696226,4.19915094 58.9270755,4.31283019 L63.3386792,12.2840566 L63.3772642,12.2840566 L67.7922642,4.31283019 C67.8491509,4.19915094 68.0196226,4.12226415 68.1167925,4.12226415 L68.4207547,4.12226415 C68.5725472,4.12226415 68.7414151,4.25490566 68.7657547,4.42632075 L70.910566,16.964434 C70.9485849,17.2121698 70.7786792,17.3826415 70.5513208,17.3826415 L68.3077358,17.3826415 C68.1366981,17.3826415 67.9666981,17.2315094 67.9446226,17.0774528 L67.0899057,11.1988679 L67.0512264,11.1988679 L63.8579245,17.1595283 C63.7972642,17.2721698 63.6283962,17.3692453 63.5312264,17.3692453 L63.190283,17.3692453 C63.074434,17.3692453 62.9232075,17.2721698 62.8680189,17.1595283 L59.6499057,11.1988679 L59.6129245,11.1988679 L58.7751887,17.0774528 C58.7570755,17.2315094 58.6036792,17.3826415 58.4138679,17.3826415 L56.1713208,17.3826415 C55.9417925,17.3826415 55.7696226,17.2121698 55.8070755,16.964434 L57.9580189,4.42632075"
          id="Fill-3"
          fill={fill}
        />
        <path
          d="M76.5980189,14.6682075 C77.3368868,14.6682075 77.9619811,14.065 77.9619811,13.2892453 C77.9619811,12.5332075 77.1465094,11.9659434 76.4092453,11.9659434 L74.8708491,11.9659434 L74.8708491,14.6682075 L76.5980189,14.6682075 Z M76.3485849,9.51018868 C77.0724528,9.51018868 77.6812264,8.90575472 77.6812264,8.15169811 C77.6812264,7.39377358 77.0724528,6.86537736 76.3485849,6.86537736 L74.8708491,6.86537736 L74.8708491,9.51018868 L76.3485849,9.51018868 Z M71.9054717,4.50339623 C71.9054717,4.31415094 72.0588679,4.14584906 72.2651887,4.14584906 L76.6917925,4.14584906 C78.9354717,4.14584906 80.7750943,5.67566038 80.7750943,7.65792453 C80.7750943,9.11396226 79.4651887,10.1723585 78.5723585,10.645 C79.5815094,11.0601887 81.119434,11.9848113 81.119434,13.7239623 C81.119434,15.8384906 79.2366981,17.3692453 76.9753774,17.3692453 L72.2651887,17.3692453 C72.0588679,17.3692453 71.9054717,17.2015094 71.9054717,17.0122642 L71.9054717,4.50339623 L71.9054717,4.50339623 Z"
          id="Fill-4"
          fill={fill}
        />
        <path
          d="M89.1201887,12.8186792 L87.6854717,9.68830189 L87.664434,9.68830189 L86.2440566,12.8186792 L89.1201887,12.8186792 Z M81.3446226,16.874434 L87.2693396,4.33113208 C87.3245283,4.21745283 87.4581132,4.12226415 87.590566,4.12226415 L87.7792453,4.12226415 C87.9111321,4.12226415 88.0434906,4.21745283 88.0998113,4.33113208 L94.0246226,16.874434 C94.1326415,17.1204717 93.9869811,17.3666981 93.7,17.3666981 L91.6016038,17.3666981 C91.2572642,17.3666981 91.1099057,17.2529245 90.9361321,16.8942453 L90.2534906,15.395 L85.1084906,15.395 L84.4303774,16.9118868 C84.3343396,17.1392453 84.1268868,17.3666981 83.749434,17.3666981 L81.6651887,17.3666981 C81.3849057,17.3666981 81.2326415,17.1204717 81.3446226,16.874434 L81.3446226,16.874434 Z"
          id="Fill-5"
          fill={fill}
        />
        <g id="Group-10">
          <mask id="mask-2" fill="white">
            <use href="#path-1" />
          </mask>
          <g id="Clip-7" />
          <path
            d="M100.703774,6.92141509 L97.9679245,6.92141509 C97.7603774,6.92141509 97.6056604,6.75254717 97.6056604,6.56245283 L97.6056604,4.50339623 C97.6056604,4.31415094 97.7603774,4.14584906 97.9679245,4.14584906 L106.45566,4.14584906 C106.663208,4.14584906 106.818868,4.31415094 106.818868,4.50339623 L106.818868,6.56245283 C106.818868,6.75254717 106.663208,6.92141509 106.45566,6.92141509 L103.719811,6.92141509 L103.719811,17.0122642 C103.719811,17.2015094 103.54717,17.3692453 103.357547,17.3692453 L101.066038,17.3692453 C100.873585,17.3692453 100.703774,17.2015094 100.703774,17.0122642 L100.703774,6.92141509"
            id="Fill-6"
            fill={fill}
            mask="url(#mask-2)"
          />
          <path
            d="M107.198113,4.61273585 C107.083962,4.36773585 107.234906,4.12226415 107.520755,4.12226415 L110.037736,4.12226415 C110.185849,4.12226415 110.318868,4.23471698 110.359434,4.32943396 L113.477358,11.2503774 L113.596226,11.2503774 L116.712264,4.32943396 C116.753774,4.23471698 116.886792,4.12226415 117.035849,4.12226415 L119.55283,4.12226415 C119.839623,4.12226415 119.990566,4.36773585 119.875472,4.61273585 L113.933962,17.1617925 C113.877358,17.2754717 113.764151,17.3692453 113.611321,17.3692453 L113.422642,17.3692453 C113.273585,17.3692453 113.156604,17.2754717 113.101887,17.1617925 L107.198113,4.61273585"
            id="Fill-8"
            fill={fill}
            mask="url(#mask-2)"
          />
          <path
            d="M19.5206604,0.0561320755 C17.8231132,0.0561320755 16.2863208,0.744150943 15.1739623,1.85650943 L8.48462264,8.58169811 C7.90066038,9.13330189 7.11283019,9.47150943 6.24622642,9.47150943 C4.44528302,9.47150943 2.98537736,8.01160377 2.98537736,6.21075472 C2.98537736,4.40990566 4.44528302,2.95 6.24622642,2.95 C7.11584906,2.95 7.90603774,3.29056604 8.49075472,3.8454717 C8.55726415,3.90858491 8.56792453,3.92084906 8.60254717,3.94660377 C8.84150943,4.12396226 9.13754717,4.22896226 9.45811321,4.22896226 C10.2514151,4.22896226 10.8945283,3.58575472 10.8945283,2.79235849 C10.8945283,2.47132075 10.7892453,2.17481132 10.6112264,1.93566038 C10.5959434,1.915 10.500566,1.81415094 10.4956604,1.80924528 C9.38150943,0.730377358 7.86320755,0.0663207547 6.18990566,0.0663207547 C2.77132075,0.0663207547 0,2.83764151 0,6.25622642 C0,9.67471698 2.77132075,12.4460377 6.18990566,12.4460377 C7.80150943,12.4460377 9.26924528,11.8301887 10.370566,10.8209434 C10.4022642,10.7918868 10.4887736,10.7109434 10.4887736,10.7109434 L17.4483962,3.73075472 C17.9996226,3.28216981 18.7028302,3.01320755 19.4688679,3.01320755 C21.2380189,3.01320755 22.6720755,4.44726415 22.6720755,6.21632075 C22.6720755,7.04075472 22.360566,7.79254717 21.8488679,8.36028302 L13.1204717,17.069717 C12.9430189,17.2471698 12.6554717,17.2471698 12.4780189,17.069717 L9.93396226,14.5256604 L9.94792453,14.5576415 C9.67764151,14.2959434 9.30924528,14.1348113 8.90330189,14.1348113 C8.07396226,14.1348113 7.40169811,14.8070755 7.40169811,15.6364151 C7.40169811,16.0483019 7.56735849,16.4214151 7.8359434,16.6926415 L7.80754717,16.6520755 L12.2245283,21.0689623 C12.5609434,21.4053774 13.1066038,21.4045283 13.4420755,21.0670755 L24.0769811,10.3295283 C24.0881132,10.3173585 24.0991509,10.3050943 24.1100943,10.2927358 C25.0789623,9.20632075 25.6677358,7.77349057 25.6677358,6.20330189 C25.6677358,2.80830189 22.915566,0.0561320755 19.5206604,0.0561320755"
            id="Fill-9"
            fill={fill}
            mask="url(#mask-2)"
          />
        </g>
      </g>
    </g>
  </svg>
);
